import { Actions, Atom, Namespace } from "@cirrus/fe-lib"
import { keys, mergeRight, pick } from "ramda"

import { CurrentUser } from "../_params.js"
import { CirrusApi } from "../../../shared/index.js"

import { call, put, takeEvery, takeLatest } from "redux-saga/effects"

export const domain = Namespace.domain(CurrentUser, "profile")

const initialState = {
  Role: 0,
  Title: "",
  Sorting: 10,
  Dashboard: false,
  Library: false,
  Collections: false,
  CreateCollections: false,
  UseTrashCan: false,
  Items: false,
  MediaElements: false,
  CreateMediaElements: false,
  Assessments: false,
  AssessmentOverview: false,
  CreateAssessments: false,
  AssessmentStatistics: false,
  EditCandidateFeedbackOption: false,
  Delivering: false,
  Schedule: false,
  Invigilation: false,
  ViewReviewSessionTab: false,
  InvigilationViewLogs: false,
  InvigilationAssessmentPrinting: false,
  DeliveringAssessmentPreview: false,
  InvigilationSendMessages: false,
  Marking: false,
  ManageAssessors: false,
  ViewAssessTab: false,
  ViewResultsTab: false,
  ViewReScoringTab: false,
  ViewRemarkingTab: false,
  VoidAttempts: false,
  ViewProctoredRecordings: false,
  Reports: false,
  ReportsCandidateResults: false,
  ReportsDeliveryVolume: false,
  ReportsAssessmentPerformance: false,
  LimitedReportsAccessOnly: false,
  AlwaysShowScoreReport: false,
  StartPage: 2,
  Participate: false,
  ManageUsers: false,
  ManageLoginAs: false,
  ManageGroups: false,
  ManageClusters: false,
  ManageContent: false,
  ManageTerms: false,
  ManageTrashCan: false,
  ManageIntegrations: false,
  ManageAssessmentSettings: false,
  ManageLearningObjectives: false,
  ManageTaxonomies: false,
  ManageLabels: false,
  ManageRegionalSettings: false,
  ManageRoles: false,
  ManageGlobalSettings: false,
  ManageSkins: false,
  ManageSeb: false,
  IsAuthor: false,
  isSystemAdministrator: false,
  CanBeDeleted: false,
  Id: "",
  Deleted: null,
  DeletedBy: null,
  TrashState: 0,
  CustomerId: 1,
}

export const actions = Actions.of(domain, [
  "profileRequested",
  "profileFetched",
  "profileFetchFailed",
  "fetchCancelled",
])

export const atom = Atom.behavior((on) => {
  on(actions.profileFetched, (state, payload) =>
    mergeRight(state, pick(keys(initialState), payload)),
  )
}, initialState)

export const effects = [
  takeLatest(actions.profileRequested, function* () {
    if (sessionStorage.getItem("Cirrus_Delivery_Mode") === "Anonymous") {
      yield put(actions.fetchCancelled())
    } else {
      try {
        const { data } = yield call(CirrusApi.user.profileGet)

        yield put(actions.profileFetched(data))
      } catch (error) {
        yield put(actions.profileFetchFailed(error))
      }
    }
  }),

  takeEvery(actions.profileFetchFailed, function* ({ error }) {
    console.error(error)
  }),
]
